module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_basefantasy.2f08ff87.png";